/**
 * @fileoverview DELETE handler for the "/companies/:company_id/custom_roles/delete_custom_role/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomRolesDeleteCustomRoleIdCacheKeys } from "./constants";
import type {
  DeleteCompaniesCompanyIdCustomRolesDeleteCustomRoleIdProps,
  CompaniesCompanyIdCustomRolesDeleteCustomRoleIdResult,
} from "./types";

export const deleteCompaniesCompanyIdCustomRolesDeleteCustomRoleId = reactQueryMutationAdapter(
  companiesCompanyIdCustomRolesDeleteCustomRoleIdCacheKeys,
  (
    props: DeleteCompaniesCompanyIdCustomRolesDeleteCustomRoleIdProps
  ): Promise<CompaniesCompanyIdCustomRolesDeleteCustomRoleIdResult> => {
    return fetch(`/companies/${props.companyId}/custom_roles/delete_custom_role/${props.id}`, "DELETE", {});
  }
);
